import React from 'react'

function PY_program_details() {
  return (
    <div>
      {/* -----------------------Mobile view----------------------- */}
      <div className="d-sm-block d-md-none">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center Program_details_1stcomp_text_mobile">
                <h1 className="display-6">Python Power Unleashed</h1>
                <p className="py-2">
                  Learn Python and its many applications! Join our cutting-edge
                  course right away to learn to code, unlock your full
                  potential, and shape a brighter tomorrow.
                </p>
              </div>
              <div className="mt-4 text-center Program_details_1stcomp_text_mobile">
                <h1 className="display-4">Overview</h1>
                <p className="py-2">
                  Take a thorough look at Python and learn about data
                  structures, advanced concepts, and programming basics.
                  Investigate database operations, optimize code efficiency, and
                  learn about Python libraries. Use pandas, statistical ideas,
                  and hypothesis testing to navigate data analysis. Take on both
                  small and large projects to fully immerse yourself in
                  real-world applications. This course gives you a strong
                  foundation and practical experience in Python, preparing you
                  for a variety of applications in the dynamic world of
                  programming and analytics—whether you're a novice or an
                  aspiring data scientist.
                </p>
              </div>
            </div>
            <div className="col-md-12">
              <div>
                <div className="Details_container shadow-lg px-1 py-4">
                  <h1 className="Details_text text-center  pb-2 border-bottom">
                    Python
                  </h1>
                  <div className="Details_text">
                    <ul className="pt-2">
                      <li>Live conversations with industry professionals</li>
                      <li className="py-3">Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className="py-3">25+ Hours of Learning</li>
                      <li>
                        Certificates from reputable MNC's around the world
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* -------------------Desktop View---------------------- */}
      <div className="d-none d-md-block">
        <div className="container">
          <div className="row">
            <div className="col-md-8 detail_1stcomp_img">
              <div className="pt-3 Program_details_1stcomp_text">
                <h1 className="fs-2">Python Power Unleashed</h1>
                <p className="py-2">
                  Learn Python and its many applications! Join our cutting-edge
                  course right away to learn to code, unlock your full
                  potential, and shape a brighter tomorrow.
                </p>
              </div>
              <div className="mt-3 Program_details_1stcomp_text">
                <h1 className="display-4">Overview</h1>
                <p className="py-2">
                  Take a thorough look at Python and learn about data
                  structures, advanced concepts, and programming basics.
                  Investigate database operations, optimize code efficiency, and
                  learn about Python libraries. Use pandas, statistical ideas,
                  and hypothesis testing to navigate data analysis. Take on both
                  small and large projects to fully immerse yourself in
                  real-world applications. This course gives you a strong
                  foundation and practical experience in Python, preparing you
                  for a variety of applications in the dynamic world of
                  programming and analytics—whether you're a novice or an
                  aspiring data scientist.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div>
                <div className=" Details_container shadow-lg px-3 py-4">
                  <h1 className="Details_text text-center  pb-4 pt-3 border-bottom">
                    Python
                  </h1>
                  <div className="Details_text ">
                    <ul className="pt-3">
                      <li>Live conversations with industry professionals</li>
                      <li className="py-3">Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className="py-3">25+ Hours of Learning</li>
                      <li>
                        Certificates from reputable MNC's around the world
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PY_program_details
